import Swal from "sweetalert2";

const showErrorAlert = (title, msg = "", jsonError = null) => {
    // Bloque de detalles técnicos
    const detailsHTML = jsonError
        ? `
      <details style="text-align: left; margin-top: 10px;">
        <summary style="cursor: pointer; font-weight: 600; color: #555;">
          Ver detalles técnicos
        </summary>
        <pre style="
          background:#fafafa;padding:12px;border-radius:6px;border:1px solid #eee;margin-top:8px;
          white-space:pre-wrap;max-height:240px;overflow:auto;font-size:13px;
        ">${escapeHtml(JSON.stringify(jsonError, null, 2))}</pre>
      </details>`
        : "";

    // 👇 Siempre lo meto en un div para estilo consistente
    const mainMessageHTML = `
        <div style="margin-bottom: 10px;">
            ${msg}
        </div>
    `;

    const fullHTML = `
        ${mainMessageHTML}
        ${detailsHTML}
    `;

    return Swal.fire({
        title,
        html: fullHTML,
        icon: "warning",
        position: "center",
        width: 600,
    });
};

// Escapa caracteres peligrosos por si acabas metiendo strings en `html`
const escapeHtml = (str) =>
    String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");

export const errorHandler = (data, setErrors = null) => {
    // 1) Normaliza la estructura de error
    let errorData = null;

    if (data?.error) {
        errorData = data.error;
    } else if (data?.errors) {
        errorData = data.errors;
    }

    const status = Number(data?.status_code) || 0;

    switch (status) {
        case 422: {
            // Validación
            if (setErrors) setErrors(errorData);
            return swalErrors(errorData); // Devuelve arreglo de mensajes
        }

        case 400: // Bad Request
        case 404: {
            // Not Found
            const msg =
                errorData?.msg ?? "Solicitud inválida o recurso no encontrado.";
            const jsonError = errorData?.jsonError ?? null;
            showErrorAlert("Alerta", msg, jsonError);
            break;
        }

        case 429: {
            // Too Many Requests
            // Puedes mostrar un mensaje específico de rate limit si no usas setErrors
            if (setErrors) {
                setErrors({
                    rate_limit: [
                        errorData.msg ??
                            "Demasiadas solicitudes, intenta más tarde.",
                    ],
                });
            } else {
                return swalErrors({
                    rate_limit: [
                        errorData.msg ??
                            "Demasiadas solicitudes, intenta más tarde.",
                    ],
                });
            }
            break;
        }

        case 401: {
            // No autenticado
            localStorage.clear();
            Swal.fire(
                "Sesión expirada",
                "Vuelve a iniciar sesión para continuar.",
                "warning"
            );
            break;
        }

        case 403: {
            // No autorizado
            Swal.fire(
                "Acceso denegado",
                "No tienes permisos para esta acción.",
                "warning"
            );
            break;
        }

        case 500: {
            // Server error
            Swal.fire(
                "Alerta",
                "Ha ocurrido un error, por favor contacta al administrador",
                "error"
            );
            break;
        }

        default: {
            console.warn("errorHandler (raw):", data);
            Swal.fire(
                "Error inesperado",
                `Código ${status || "desconocido"}. Contacta a backend.`,
                "warning"
            );
            break;
        }
    }
};

const swalErrors = (errors) => {
    const msgErrors = [];

    // Soporta tanto { campo: ["msg1", "msg2"] } como { campo: "msg" }
    if (errors && typeof errors === "object") {
        Object.entries(errors).forEach(([_, value]) => {
            const first = Array.isArray(value)
                ? value[0]
                : value ?? "Campo inválido.";
            msgErrors.push(`• ${String(first)}`);
        });
    } else if (typeof errors === "string") {
        msgErrors.push(`• ${errors}`);
    }

    Swal.fire({
        title: "Alerta",
        html: `
      <p style="text-align: initial">
        Hay campos <b>incorrectos</b>. Revisa los campos marcados.<br/><br/>
        ${msgErrors.join("<br/>")}
      </p>
    `,
        icon: "warning",
        width: 500,
    });

    return msgErrors;
};
